import { Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { PlacesService } from '../../../services/places/places.service';

@Component({
  selector: 'app-google-places-location',
  templateUrl: './google-places-location.component.pug',
  styleUrls: ['./google-places-location.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class GooglePlacesLocationComponent {
  @Input() location = '';
  @Input() error = false;
  @Input() isTalentPoolTab = false;
  @Output() locationChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private places: PlacesService,
  ) {
  }

  locationSelect(event) {
    const { target: { value } } = event;

    if(this.location !== value) {
      this.location = value;
      this.locationChange.emit(value);
    }
  }

  updateLocation(newLocation) {
    if (this.location !== newLocation) {
      this.location = newLocation;
      this.locationChange.emit(newLocation);
    }
  }

  search: OperatorFunction<string, readonly string[]> = (searchTerm: Observable<string>) =>
    searchTerm.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(term => {
        return this.places.get({ search_string: term }).pipe(
          catchError(() => of([]))
          )
      }),
    )

}
